import { render } from "./Header.vue?vue&type=template&id=2f149414&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2f149414&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f149414"]])

export default __exports__